
import React, { useContext } from 'react';
import { StyleContext } from '../context';
import { textColor } from '../helpers/functions/colors';

const TableHeader = () =>{
    const {variant, type} = useContext(StyleContext)
    return (
        <thead>
            <tr>
                <th><h3 className={textColor(variant)}>{type}</h3></th>
                <th><h3 className={textColor(variant)}>Value</h3></th>
                <th><h3 className={textColor(variant)}>Action</h3></th>
    
            </tr>
        </thead>
    )
}


export default TableHeader;
